import { createSlice } from '@reduxjs/toolkit';

const showQuizComponent = createSlice({
  name: 'showQuizComponent',
  initialState: {
    showQuizComponent: false,
  },
  reducers: {
    handleShowQuizComponent: (state, action) => {
      state.showQuizComponent = action.payload;
    },
  },
});

export const { handleShowQuizComponent } = showQuizComponent.actions;

export default showQuizComponent.reducer;
